/**
 * ChatGate - "Waiting for the author" overlay shown for 3s before a chat opens.
 */
import { useEffect } from 'preact/hooks';

const WAIT_MS = 3000;

export function ChatGate({ onReady }) {
  useEffect(() => {
    const t = window.setTimeout(onReady, WAIT_MS);
    return () => window.clearTimeout(t);
  }, [onReady]);

  return (
    <div class="chatgate">
      <div class="chatgate__box">
        <div class="chatgate__spinner" />
        <div class="chatgate__text">Waiting for the author</div>
      </div>
    </div>
  );
}
